<template>
  <div v-if="loaderData != null && loaderData.display == true"
    class="w-full lg:w-lg"
    style="position:fixed;top:200px;z-index:100;">

    <div class="max-w-full text-center">
      <div class="inline-block text-center px-10 py-4 rounded-sm"
        style="background-color: #E4E2E5;opacity:0.8;width:260px;">
        <img src="/static/img/ajax-loader.gif" class="inline" />
        <div class="mt-4 text-sm">
          {{ loaderData.message }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  export default {

    props : {
      loaderData : {
        type    : Object,
        required: true,
      }
    },
  }

</script>

<style scoped>

</style>
